/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadServiceResource {
    getFixupPrototypeFunction() { return WorkloadServiceResource.fixupPrototype; }

    static newInstance(model: Partial<WorkloadServiceResource>): WorkloadServiceResource {
        let obj = Object.assign(new WorkloadServiceResource(), model);
        WorkloadServiceResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadServiceResource>): WorkloadServiceResource {
        if (!model) return null;
        return WorkloadServiceResource.newInstance(<WorkloadServiceResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadServiceResource) {
        if (!obj) return;

        models.WorkloadServiceResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadServiceResource): boolean {
        Object.setPrototypeOf(obj, WorkloadServiceResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud Provider
     */
    cloud: models.CloudServiceName;

    /**
     * Resource Category
     */
    category: string;

    /**
     * Resource Type
     */
    resource_type: string;

    /**
     * Resource Name
     */
    resource: string;

    /**
     * Whether resource has tag support
     */
    supports_tags: boolean;

}
